import session from "@/api/session";

export default {
  fetchTasks() {
    return session.get(`/voip/number-pool/actions/refresh/`);
  },
  newTask() {
    return session.post(`/voip/number-pool/actions/refresh/`);
  },
};
